import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const PrevRecurringRevenue = ({ size }) => {
  const { label, value, tooltip, url } = useSelector(
    (state) => state.membershipRevenue.membershipDraft.recurring?.prevRecurringRevenueMTD
  );
  const currencySymbol = useSelector(
    (state) => state.membershipRevenue.membershipDraft.currencySymbol
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <DataDisplay
      label={label}
      size={size}
      toolTipContent={tooltip || ""}
      type="money"
      url={url}
      currency={currencySymbol}
      value={value}
      disableAnimation={isUserQa}
    />
  );
};

export default PrevRecurringRevenue;
